<template>
	<k-panel :class="[get_color]" class="elevation-0 ma-0 pa-0 ks-monitor-video">
		<template #title>
			<div style="display: grid; grid-template-columns: max-content minmax(0, 1fr); min-width: 0; color: var(--ks-font-color-primary);" class="ks-font-size-xs pl-1" @click.stop="emit_title_click">
				<div>
					<template v-if="iconColor">
						<k-icon :color="iconColor" small class="mr-2">circle</k-icon>
					</template>
				</div>
				<div ref="title_el" :key="title_tooltip" class="ks-monitor-video-title" v-tooltip.bottom="title_tooltip">
					<slot name="title"></slot>
				</div>
			</div>
		</template>
		<template #buttons>
			<span style="text-wrap: nowrap;">
				<k-btn no-margin size="xs" no-margin icon :href="get_url" target="_blank" :disabled="!load_player" v-if="showUrl" icon-name="play_circle_outline"></k-btn>
				<k-btn no-margin size="xs" no-margin icon @click.stop="emit_edit" v-if="edit" icon-name="edit"></k-btn>
 				<k-btn no-margin size="xs" no-margin icon @click.stop="emit_close" v-if="closable" icon-name="close"></k-btn>
	    </span>
		</template>

		<template #default>
    	<k-video-player class="elevation-0 pa-0" v-model="player_info" :url="get_url" :load-player="load_player" style=" margin-top: -8px; position: relative; z-index: 1; background-color: black;">
        <span style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%; text-align: center;" v-if="!load_player">{{playerText}}</span>
      </k-video-player>
		</template>

		<template #footer>
			<div class="mb-1" style="position: relative; margin-top: -8px; padding-top: 5px; margin-left: -8px; margin-right: -8px; padding-left: 8px; padding-right: 8px; height: 20px;">

				<div v-if="progress" :class="get_progress_color" :style="{'width': progressPercent + '%'}" style="border-radius: 6px; position: absolute; top: 10px; height: 12px; left: 0; bottom: 0; z-index: 1;"></div>

				<div class="ks-font-size-s" style="display: grid; grid-template-columns: 1fr 1fr; width: 100%; height: 20px; line-height: 15px; color: var(--ks-font-color-secondary);">
				<div>
   				<k-menu style="z-index: 2; min-width: 60px; line-height: 22px;" v-if="urls.length > 1">
   					<template #activator>

   						<div style="display:grid; grid-template-columns: 1fr 30px;">
								<div>{{ current_url.title }}</div>
								<div><k-icon small>arrow_drop_down</k-icon></div>
							</div>
   					</template>
   					<template #default>
   						<k-list :items="urls" @click="select_url">
   							<template #default="{ item }">
   								{{item.title}}
   							</template>
        			</k-list>
        		</template>
      		</k-menu>
      		<span v-if="showPlayerInfo && player_info.width && player_info.height" style="z-index: 2; line-height: 22px;">
      			{{player_info.width}} x {{player_info.height}}
      		</span>
      	</div>
	      <div :style="{'grid-template-columns': stoppable ? '1fr 16px' : '1fr', 'padding-right': stoppable ? '18px' : '0'}" style="display: grid; height: 24px; line-height: 22px; overflow: hidden;">
		      <span style="z-index: 2;">
  			    <slot name="subtitle"></slot>
	  		  </span>
      		<template v-if="stoppable">
      			<span style="z-index: 2;">
      				<slot name="stop"></slot>
      			</span>
      		</template>
      	</div>
    		</div>
    	</div>
		</template>
	</k-panel>
</template>

<script>

export default {
	props: {
		"urls": {
			type: Array,
			default: function() {return []}
		},
		"color": String,
		"icon-color": String,
		"stoppable": {
			type: Boolean,
			default: false
		},
		"closable": {
			type: Boolean,
			default: true
		},
		"stop-tooltip": String,
		"progress-percent": {
			type: Number,
			default: 0
		},
		"progress-warning": {
			type: Boolean,
			default: false
		},
		"progress": {
			type: Boolean,
			default: true
		},
		"show-player": {
			type: Boolean,
			default: true
		},
		"show-player-info": {
			type: Boolean,
			default: true
		},
		"player-text": {
			type: String,
			default: "No preview"
		},
		"edit": {
			type: Boolean,
			default: false
		},
		"edit-text": {
			type: String,
			default: "Edit"
		},
		"hide-footer": {
			type: Boolean,
			default: false
		},
		"show-url": {
			type: Boolean,
			default: true
		}
	},
	components: {
	},
	mounted() {
		this.update_title_tooltip();
	},
	updated() {
		this.update_title_tooltip();
	},
	data() {
		return {
			player_info: {width: 0, height: 0},
			selected_title: null,
			title_tooltip: ""
		}
	},
	computed: {
		current_url() {
			var selected = this.urls.find(u => u.title === this.selected_title);
			return selected || this.urls[0] || {};
		},
		get_progress_color() {
			if (this.progressWarning == true) return "progress-warning";
			return "ks-monitor-video-color-success-progress";
		},
		get_color() {
			return "ks-monitor-video-color-" + this.color;
		},
		load_player() {
			return this.showPlayer && this.get_url != "";
		},
		get_url () {
			return this.current_url.url || "";
		}
	},
	methods: {
		update_title_tooltip () {
			var el = this.$refs.title_el;
			if (!el) return;
			var text = (el.textContent || "").replace(/\s+/g, " ").trim();
			// tooltip renders its value as HTML
			text = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
			if (text !== this.title_tooltip) this.title_tooltip = text;
		},
		select_url (url) {
			this.selected_title = url.title;
		},
		emit_close () {
			this.$emit("close");
		},
		emit_title_click () {
			this.$emit("titleclick");
		},
		emit_edit () {
			this.$emit("edit");
		}
	}
}
</script>

<style>
	.ks-panel.ks-monitor-video > .ks-panel-heading {
		grid-template-columns: minmax(0, 1fr) max-content max-content;
	}
	.ks-panel.ks-monitor-video > .ks-panel-heading > .ks-panel-title {
		justify-self: stretch;
		min-width: 0;
		overflow: hidden;
	}
	.ks-monitor-video-title {
		min-width: 0;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
</style>

<style scoped>
	/* .elevation-0 sets the border with !important */
	.ks-monitor-video {
		isolation: isolate;
		border-color: var(--ks-monitor-video-border-color, var(--ks-col-secondary)) !important;
	}

	.ks-monitor-video-color-success {
		--ks-monitor-video-border-color: var(--ks-col-success-dark);
	}

	.ks-monitor-video-color-danger {
		--ks-monitor-video-border-color: var(--ks-col-danger-dark);
	}
	.ks-monitor-video-color-warning {
		--ks-monitor-video-border-color: var(--ks-col-warning);
	}

	.ks-monitor-video-color-primary {
		--ks-monitor-video-border-color: var(--ks-col-secondary);
	}
	.ks-monitor-video-color-past {
		--ks-monitor-video-border-color: var(--ks-col-secondary);
		opacity: 0.3;
	}

	.ks-monitor-video-color-success-progress {
		background: var(--ks-col-secondary);
	}


	.progress-warning {
		animation: rotate-bg-color-dark 0.7s infinite;
	}
	@keyframes rotate-bg-color-dark {
    	0% {
      		background-color: var(--ks-background-color);
    	}
    	25% {
      		background-color: var(--ks-col-danger-dark);
    	}
    	50% {
     		background-color: var(--ks-col-danger);
    	}
    	75% {
      		background-color: var(--ks-col-danger-dark);
    	}
    	100% {
      		background-color: var(--ks-background-color);
    	}
	}
</style>
